import { NumericFormat } from 'react-number-format';
import { noop } from 'lodash';
import cx from 'classnames';

import {
  emptyValue,
  formatParams,
} from './TransactionAlertsTableValue.constants';
import styles from './TransactionAlertsTableValue.module.sass';

interface TransactionAlertsTableValueInterface {
  isActive?: boolean;
  isEditable?: boolean;
  direct: number | null;
  indirect: number | null;
  onClick?: () => void;
}

export const TransactionAlertsTableValue = ({
  isActive = false,
  isEditable = false,
  direct,
  indirect,
  onClick = noop,
}: TransactionAlertsTableValueInterface) => {
  const hasValue = !!direct || !!indirect;

  const classes = cx(styles.value, {
    [styles['is-editable']]: isEditable,
    [styles['is-active']]: isActive,
  });

  return (
    <div className={classes} onClick={onClick}>
      {hasValue && (
        <>
          <div className={styles.direct}>
            {direct ? (
              <NumericFormat {...formatParams} value={direct} />
            ) : (
              emptyValue
            )}
          </div>
          <span className={styles.separator}>/</span>
          <div className={styles.indirect}>
            {indirect ? (
              <NumericFormat {...formatParams} value={indirect} />
            ) : (
              emptyValue
            )}
          </div>
        </>
      )}
    </div>
  );
};
